export default __webpack_public_path__ + "static/media/RistekLogo-dark.a518f902.svg";